import EmailAddress from "_shared/email-addresses/email-address";

export default class AcceptOpenEntityMemberInvitationAPIRequest {
  public readonly email: string;

  public constructor(email: EmailAddress) {
    this.email = email.value;
  }
}
